module.exports = __webpack_public_path__ + "h5/img/shouzhi.3d676d4f.png";